import { useCallback, useState } from 'react';

import EditIcon from '@mui/icons-material/Edit';

import { SpeedDial } from '../../components/SpeedDial';
import { useAuthenticationContext } from '../../contexts/AuthenticationContext/hooks/useAuthenticationContext.hook';

import { MyDataDialog } from './MyDataDialog';

interface Props {
  readonly onUpdated?: () => void;
}

export const MyDataAction = ({ onUpdated }: Readonly<Props>) => {
  const { authenticationData } = useAuthenticationContext();
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => {
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  if (!authenticationData) {
    return null;
  }

  return (
    <>
      <SpeedDial
        actions={[
          {
            id: 'editMyData',
            icon: <EditIcon />,
            name: 'Modifier Mes Données',
            onClick: open,
          },
        ]}
        title="Actions possibles sur Mon Compte"
      />
      {isOpen ? (
        <MyDataDialog
          email={authenticationData.email}
          onClose={close}
          onUpdated={onUpdated}
        />
      ) : null}
    </>
  );
};
